import { Col, Row, Table } from "antd";
import { ColumnsType } from 'antd/lib/table';
import { CSSProperties, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { chucVu } from "../../constants";
import { formatVNDIn, layTenNhomNhanSu } from "../../helpers/common";
import { ChiTietBaoHiem } from "../../models/baohiem/BaoHiem";
import { NhanVienResponse } from "../../models/nhanvien/NhanVien";
import { layDanhMucNhanVien } from "../../services/danhmuc";

const PrintPage = styled.div`
  @media print {
    /* Thiết lập lề và kích thước giấy A4 */
    @page {
      size:landscape;
      background-color: white;
      margin-top: 2cm;
      margin-bottom: 2cm;
      margin-left: 1cm;
      margin-right: 1cm;
    }
    div {
      font-family:'Times New Roman',Times,serif !important;
    }
    label {
      font-family:'Times New Roman',Times,serif !important;
    }
      .custom-table-anttd tr:last-child td,
  .custom-table-anttd tr:last-child th {
    border-bottom: 1px solid black;
  }
    .print-footer {
      page-break-after: avoid;
    }
  }
`;

type InBHXHDataType = {
    key: any,
    hoTen?: any,
    chucVu?: any,
    luongCoBan?: any,
    luongPhuCap?: any,
    luongKhac?: any,
    tongThuNhap?: any,
    luongThemGio?: any,
    ghiChu?: any,
    STT?: any,
    soNgayCongTinhLuong?: any,
    heSo?: any,
    mucLuongTheoChucDanh?: any,
    mucLuongTheoHDLD?: any,
    giamCongDoan?: any,
    giamBHXH?: any,
    luongConNhan?: any,
    soNgayCong?: any,
    chiAnCa?: any,
    thanhTienAnCa?: any,
    mucKhoanDienThoai?: any,
    mucKhoanCTP?: any,
    bacLuongChuyenVien?: any,
    tongCong?: any,
    bacLuongCanSu?: any,
    mucPhuCapChucVu?: any,
    tienLuongDongBHXH?: any,
    xepLoai?: any,
    heSoXepLoai?: any,
    luongThucNhan?: any,
    bacLuongNhanVien?: any,
    heSoLuong?: any,
    phuCap?: any,
    bac?: any,
    mucLuongDongBaoHiem?: any,
    nlD_BHXH?: any,
    nlD_BHYT?: any,
    nlD_BHTN?: any,
    nlD_tong?: any,
    dV_BHXH?: any,
    dV_BHYT?: any,
    dV_BHTN?: any,
    dV_tong?: any,
    tongNop?: any,
    phiCD?: any,
};

const PrintBHXH = ({ dataSource, namThang, thangNamTitle, dsNhomNhanSu }: { dataSource: any[], namThang: any, thangNamTitle: string, dsNhomNhanSu?: any[] }) => {
    const [title, setTitle] = useState("");
    const [columns, setColumns] = useState<any>();
    const [dataTable, setDataTable] = useState<any>();
    const [chanhVP, setChanhVP] = useState<NhanVienResponse>();
    const [giamDoc, setGiamDoc] = useState<NhanVienResponse>();
    const user = useSelector((state: any) => state.auth.currentUser);
    const now = new Date();
    
    const columnsBaoHiem: ColumnsType<InBHXHDataType> = [
        { title: 'STT', dataIndex: 'STT', key: 'STT', align: 'center' },
        { title: 'Họ và tên', dataIndex: 'hoTen', key: 'hoTen' },
        { title: 'Chức vụ', dataIndex: 'chucVu', key: 'chucVu' },
        { title: 'Bậc', dataIndex: 'bac', key: 'bac', align: 'center', width: 50 },
        { title: 'Hệ số lương', dataIndex: 'heSoLuong', key: 'heSoLuong', align: 'center', width: 60 },
        { title: 'Tiền lương đóng BHXH', dataIndex: 'mucLuongDongBaoHiem', key: 'mucLuongDongBaoHiem', align: 'center', width: 110 },
        {
            title: 'Người lao động chi trả', key: 'nld', align: 'center', children: [
                { title: 'BHXH 8%', dataIndex: 'nlD_BHXH', key: 'nlD_BHXH', align: 'center' },
                { title: 'BHYT 1.5%', dataIndex: 'nlD_BHYT', key: 'nlD_BHYT', align: 'center' },
                { title: 'BHTN 1%', dataIndex: 'nlD_BHTN', key: 'nlD_BHTN', align: 'center' },
                { title: 'Tổng cộng', dataIndex: 'nlD_tong', key: 'nlD_tong', align: 'center' },
            ]
        },
        {
            title: 'Người sử dụng LĐ chi trả', key: 'nsd', align: 'center', children: [
                { title: 'BHXH 17.5%', dataIndex: 'dV_BHXH', key: 'dV_BHXH', align: 'center' },
                { title: 'BHYT 3%', dataIndex: 'dV_BHYT', key: 'dV_BHYT', align: 'center' },
                { title: 'BHTN 1%', dataIndex: 'dV_BHTN', key: 'dV_BHTN', align: 'center' },
                { title: 'Tổng cộng', dataIndex: 'dV_tong', key: 'dV_tong', align: 'center' },
            ]
        },
        { title: 'Tổng cộng bảo hiểm phải nộp', dataIndex: 'tongNop', key: 'tongNop', align: 'center', width: 120 },
        { title: 'Kinh phí CĐ 2%', dataIndex: 'phiCD', key: 'phiCD', align: 'center', width: 80 },
        { title: 'Ghi chú', dataIndex: 'ghiChu', key: 'ghiChu', align: 'center' },
    ];
    
    const layChanhVanPhong = async () => {
        let rs = await layDanhMucNhanVien();
        setChanhVP(rs.filter((item: any) => item.idChucVu == chucVu.chanhVanPhong)[0])
        setGiamDoc(rs.filter((item: any) => item.idChucVu == chucVu.giamDoc)[0])
    }

    const cssFormInNoiDungTien: CSSProperties = {
        textAlign: "right",
        paddingRight: "10px",
        fontFamily: 'Times New Roman'
    };
    const cssFormInNoiDungBenTrai: CSSProperties = {
        textAlign: "left",
        paddingRight: "5px",
        fontFamily: 'Times New Roman'
    };

    const renderPage = () => {
        setTitle("BẢNG TÍNH BẢO HIỂM XÃ HỘI, BẢO HIỂM Y TẾ, BẢO HIỂM THẤT NGHIỆP, KINH PHÍ CÔNG ĐOÀN");
        setColumns(columnsBaoHiem);

        const romanNumerals = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X"];

        // Group items by idNhomNhanSu
        const groups: { [key: number]: ChiTietBaoHiem[] } = {};
        (dataSource || []).forEach((item) => {
            const nhomId = item.idNhomNhanSu || (item.isQuanLy ? 3 : 1);
            if (!groups[nhomId]) {
                groups[nhomId] = [];
            }
            groups[nhomId].push(item);
        });

        let sortedGroupIds: number[] = [];
        const allGroupIds = Object.keys(groups).map(Number);

        if (dsNhomNhanSu && dsNhomNhanSu.length > 0) {
            const dbOrder = dsNhomNhanSu.map((x: any) => x.id);
            sortedGroupIds = [
                ...dbOrder.filter(id => allGroupIds.includes(id)),
                ...allGroupIds.filter(id => !dbOrder.includes(id))
            ];
        } else {
            const preferredOrder = [3, 7, 1];
            sortedGroupIds = [
                ...preferredOrder.filter(id => allGroupIds.includes(id)),
                ...allGroupIds.filter(id => !preferredOrder.includes(id))
            ];
        }

        const rows: InBHXHDataType[] = [
            // The formula/guide row
            {
                key: "guide-row",
                STT: <em>A</em>,
                hoTen: <em>B</em>,
                chucVu: <em>C</em>,
                bac: <em>(1)</em>,
                heSoLuong: <em>(2)</em>,
                mucLuongDongBaoHiem: <em>(3)</em>,
                nlD_BHXH: <em>(4)=(3)x8%</em>,
                nlD_BHYT: <em>(5)=(3)x1.5%</em>,
                nlD_BHTN: <em>(6)=(3)x1%</em>,
                nlD_tong: <em>(7)=(4)+(5)+(6)</em>,
                dV_BHXH: <em>(8)=(3)x17.5%</em>,
                dV_BHYT: <em>(9)=(3)x3%</em>,
                dV_BHTN: <em>(10)=(3)x1%</em>,
                dV_tong: <em>(11)=(8)+(9)+(10)</em>,
                tongNop: <em>(12)=(7)+(11)</em>,
                phiCD: <em>(13)=(3)x2%</em>,
                ghiChu: <em>(14)</em>
            }
        ];

        // Calculate Grand Totals
        let grandMucLuongDongBaoHiem = 0;
        let grandNldBhxh = 0;
        let grandNldBhyt = 0;
        let grandNldBhtn = 0;
        let grandDvBhxh = 0;
        let grandDvBhy = 0;
        let grandDvBht = 0;
        let grandCD = 0;

        (dataSource || []).forEach(item => {
            grandMucLuongDongBaoHiem += item.mucLuongDongBaoHiem || 0;
            grandNldBhxh += item.nlD_BHXH || 0;
            grandNldBhyt += item.nlD_BHYT || 0;
            grandNldBhtn += item.nlD_BHTN || 0;
            grandDvBhxh += item.dV_BHXH || 0;
            grandDvBhy += item.dV_BHYT || 0;
            grandDvBht += item.dV_BHTN || 0;
            grandCD += item.congDoan || 0;
        });

        // 1. Grand Summary row
        rows.push({
            key: "grand-summary",
            STT: "",
            hoTen: <strong>Tổng cộng</strong>,
            chucVu: "",
            bac: "",
            heSoLuong: "",
            mucLuongDongBaoHiem: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(grandMucLuongDongBaoHiem)}</strong></div>,
            nlD_BHXH: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(grandNldBhxh)}</strong></div>,
            nlD_BHYT: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(grandNldBhyt)}</strong></div>,
            nlD_BHTN: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(grandNldBhtn)}</strong></div>,
            nlD_tong: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(grandNldBhxh + grandNldBhyt + grandNldBhtn)}</strong></div>,
            dV_BHXH: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(grandDvBhxh)}</strong></div>,
            dV_BHYT: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(grandDvBhy)}</strong></div>,
            dV_BHTN: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(grandDvBht)}</strong></div>,
            dV_tong: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(grandDvBhxh + grandDvBhy + grandDvBht)}</strong></div>,
            tongNop: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(grandNldBhxh + grandNldBhyt + grandNldBhtn + grandDvBhxh + grandDvBhy + grandDvBht)}</strong></div>,
            phiCD: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(grandCD)}</strong></div>,
            ghiChu: ""
        });

        let employeeSTT = 1;

        sortedGroupIds.forEach((nhomId, groupIdx) => {
            const groupItems = groups[nhomId];
            let groupName = "";
            if (dsNhomNhanSu && dsNhomNhanSu.length > 0) {
                const matchedNhom = dsNhomNhanSu.find((x: any) => x.id === nhomId);
                groupName = matchedNhom ? matchedNhom.ten : layTenNhomNhanSu(nhomId);
            } else {
                groupName = nhomId === 7 ? "Trưởng Ban kiểm soát" : (nhomId === 3 ? "Ban điều hành" : (nhomId === 1 ? "Người lao động" : "Nhóm khác"));
            }
            const groupRoman = romanNumerals[groupIdx] || (groupIdx + 1).toString();

            // Calculate Group Totals
            let groupMucLuongDongBaoHiem = 0;
            let groupNldBhxh = 0;
            let groupNldBhyt = 0;
            let groupNldBhtn = 0;
            let groupDvBhxh = 0;
            let groupDvBhy = 0;
            let groupDvBht = 0;
            let groupCD = 0;

            groupItems.forEach((item) => {
                groupMucLuongDongBaoHiem += item.mucLuongDongBaoHiem || 0;
                groupNldBhxh += item.nlD_BHXH || 0;
                groupNldBhyt += item.nlD_BHYT || 0;
                groupNldBhtn += item.nlD_BHTN || 0;
                groupDvBhxh += item.dV_BHXH || 0;
                groupDvBhy += item.dV_BHYT || 0;
                groupDvBht += item.dV_BHTN || 0;
                groupCD += item.congDoan || 0;
            });

            // Add Group Summary row
            rows.push({
                key: `group-summary-${nhomId}`,
                STT: <strong>{groupRoman}</strong>,
                hoTen: <strong>{groupName}</strong>,
                chucVu: "",
                bac: "",
                heSoLuong: "",
                mucLuongDongBaoHiem: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(groupMucLuongDongBaoHiem)}</strong></div>,
                nlD_BHXH: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(groupNldBhxh)}</strong></div>,
                nlD_BHYT: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(groupNldBhyt)}</strong></div>,
                nlD_BHTN: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(groupNldBhtn)}</strong></div>,
                nlD_tong: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(groupNldBhxh + groupNldBhyt + groupNldBhtn)}</strong></div>,
                dV_BHXH: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(groupDvBhxh)}</strong></div>,
                dV_BHYT: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(groupDvBhy)}</strong></div>,
                dV_BHTN: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(groupDvBht)}</strong></div>,
                dV_tong: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(groupDvBhxh + groupDvBhy + groupDvBht)}</strong></div>,
                tongNop: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(groupNldBhxh + groupNldBhyt + groupNldBhtn + groupDvBhxh + groupDvBhy + groupDvBht)}</strong></div>,
                phiCD: <div style={cssFormInNoiDungTien}><strong>{formatVNDIn(groupCD)}</strong></div>,
                ghiChu: ""
            });

            // Add employee rows
            groupItems.forEach((item, index) => {
                rows.push({
                    key: `employee-${item.id}-${nhomId}-${index}`,
                    STT: employeeSTT++,
                    hoTen: <div style={cssFormInNoiDungBenTrai}>{item.hoTen}</div>,
                    chucVu: <div style={cssFormInNoiDungBenTrai}>{item.chucVu}</div>,
                    bac: item.bac,
                    heSoLuong: item.heSoLuong,
                    mucLuongDongBaoHiem: <div style={cssFormInNoiDungTien}>{formatVNDIn(item.mucLuongDongBaoHiem)}</div>,
                    nlD_BHXH: <div style={cssFormInNoiDungTien}>{item.nlD_BHXH !== 0 && item.nlD_BHXH !== null ? formatVNDIn(item.nlD_BHXH) : "-"}</div> || "-",
                    nlD_BHYT: <div style={cssFormInNoiDungTien}>{item.nlD_BHYT !== 0 && item.nlD_BHYT !== null ? formatVNDIn(item.nlD_BHYT) : "-"}</div> || "-",
                    nlD_BHTN: <div style={cssFormInNoiDungTien}>{item.nlD_BHTN !== 0 && item.nlD_BHTN !== null ? formatVNDIn(item.nlD_BHTN) : "-"}</div> || "-",
                    nlD_tong: <div style={cssFormInNoiDungTien}>{formatVNDIn(item.nlD_BHXH + item.nlD_BHYT + item.nlD_BHTN)}</div>,
                    dV_BHXH: <div style={cssFormInNoiDungTien}>{item.dV_BHXH !== 0 && item.dV_BHXH !== null ? formatVNDIn(item.dV_BHXH) : "-"}</div> || "-",
                    dV_BHYT: <div style={cssFormInNoiDungTien}>{item.dV_BHYT !== 0 && item.dV_BHYT !== null ? formatVNDIn(item.dV_BHYT) : "-"}</div> || "-",
                    dV_BHTN: <div style={cssFormInNoiDungTien}>{item.dV_BHTN !== 0 && item.dV_BHTN !== null ? formatVNDIn(item.dV_BHTN) : "-"}</div> || "-",
                    dV_tong: <div style={cssFormInNoiDungTien}>{formatVNDIn(item.dV_BHXH + item.dV_BHYT + item.dV_BHTN)}</div>,
                    tongNop: <div style={cssFormInNoiDungTien}>{formatVNDIn(item.nlD_BHXH + item.nlD_BHYT + item.nlD_BHTN + item.dV_BHXH + item.dV_BHYT + item.dV_BHTN)}</div>,
                    phiCD: <div style={cssFormInNoiDungTien}>{formatVNDIn(item.congDoan)}</div>,
                    ghiChu: item.ghiChu
                });
            });
        });

        setDataTable(rows);
    };
    useEffect(() => {
        renderPage();
        layChanhVanPhong();
    }, [dataSource]);

    return (
        <>
            <section>
                <div style={{ backgroundColor: 'white' }}>
                    <PrintPage >
                        <div className="text-center pt-2">
                            <Row gutter={8}>
                                <Col span={12} >
                                    <div style={{ fontFamily: 'Times New Roman' }}>ỦY BAN NHÂN DÂN THÀNH PHỐ<br /><label><span style={{ fontFamily: 'Times New Roman' }}> QUỸ ĐẦU TƯ PHÁT TRIỂN</span><hr style={{ borderTop: "1px solid", width: "60%", marginLeft: '12mm', marginTop: "1px", marginBottom: "2px" }} /> </label></div>
                                </Col>
                                <Col span={12}  >
                                    <label style={{ fontFamily: 'Times New Roman' }}>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM <br /> <span style={{ fontFamily: 'Times New Roman' }}>Độc lập - Tự do  - Hạnh phúc</span><hr style={{ borderTop: "1px solid", width: "50%", marginLeft: '18mm', marginTop: "1px", marginBottom: "2px" }} /> </label>
                                </Col>
                                <Col span={24} >
                                    <label style={{ fontFamily: 'Times New Roman' }}>{title} <br />{thangNamTitle}</label>
                                </Col>
                            </Row>
                        </div>
                        <Row>
                            <Col span="24">
                                <div className="card-primary" >
                                    <Table
                                        dataSource={dataTable}
                                        pagination={false}
                                        size="small"
                                        columns={columns}
                                        locale={{ emptyText: "Không có dữ liệu" }}
                                        className="custom-table-anttd"
                                    />
                                </div>
                            </Col>
                        </Row>
                        <div className="print-footer">
                            <div className="text-center" style={{ marginTop: '25px' }}>
                                <Row gutter={8}>
                                    <Col span={8} >
                                    </Col>
                                    <Col span={8} >
                                    </Col>
                                    <Col span={8}  >
                                        <div className="font-italic" style={{ fontFamily: 'Times New Roman' }}>Đà Nẵng, ngày {("0" + now.getDate()).slice(-2)} tháng {("0" + (now.getMonth() + 1)).slice(-2)} năm {now.getFullYear()}</div>
                                    </Col>
                                </Row>
                                <Row gutter={8}>
                                    <Col span={8} >
                                        <label style={{ fontFamily: 'Times New Roman' }}>Người lập</label>
                                    </Col><Col span={8} >
                                        <label style={{ fontFamily: 'Times New Roman' }}>Chánh Văn phòng</label>
                                    </Col>
                                    <Col span={8}  >
                                        <label style={{ fontFamily: 'Times New Roman' }}>Giám đốc</label>
                                    </Col>
                                </Row>
                            </div>
                            <div className="text-center" style={{ paddingTop: "100px" }}>
                                <Row gutter={8}>
                                    <Col span={8}  >
                                        <label style={{ fontFamily: 'Times New Roman' }}>{user?.hoTen}</label>
                                    </Col>
                                    <Col span={8} >
                                        <label style={{ fontFamily: 'Times New Roman' }}>{chanhVP?.hoTen}</label>
                                    </Col>
                                    <Col span={8}  >
                                        <label style={{ fontFamily: 'Times New Roman' }}>{giamDoc?.hoTen}</label>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </PrintPage>
                </div>
            </section>
        </>
    )

}
export default PrintBHXH;
